import type { RegionPartsFragment } from '~/apollo/generated/v4/graphql';

// Hide the map for these regions
// https://github.com/omt-tech/safari/issues/1953
export function isGlobalRegion(region: Pick<RegionPartsFragment, 'country'>) {
  return region.country === 'Unassigned';
}

export function locationString(
  r: Pick<RegionPartsFragment, 'country' | 'location'>,
) {
  if (r.location && r.country) return `${r.location}, ${r.country}`;
  if (r.location) return r.location;
  if (r.country) return r.country;
  return '';
}

// export const initialRegion = (
//   region?: RegionPartsFragment,
// ): RegionFormValues => ({
//   name: region?.name ?? '',
//   description: region?.description ?? '',
//   basins: region?.basins ?? '',
//   country: region?.country ?? '',
//   location: region?.location ?? '',
// });

// export const regionSchema = z.object({
//   name: z.string(),
//   description: z.string(),
//   location: z.string(),
//   country: z.string(),
//   basins: z.preprocess(ppStringOrNull, z.string().nullable()),
// });

// export type RegionFormValues = {
//   name: string;
//   description: string;
//   basins: string;
//   country: string;
//   location: string;
// };
